import React from 'react';

const ChevronIcon = ({ direction = 'down', className, size = 16, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      d={direction === 'up' ? 'M12 10L8 6L4 10' : 'M4 6L8 10L12 6'}
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ChevronIcon;
